export const CLIENT_PROFILE_DETAILS_ENTRY = {
  NOT_FOUND: 'The client profile entry details were not found',
  DEFAULT: 'Client profile entry details were found',
};


// WEBPACK FOOTER //
// ./src/features/client-profile/constants/clientProfileEntryDetailsMessages.js